function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1980(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.95,
    height: 9.83,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.22875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 4.915
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.83,
    width: 25.95,
    height: 21.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 20.42
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.01,
    width: 25.95,
    height: 25.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.104
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 43.77
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.54,
    width: 25.95,
    height: 29.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 71.49
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.44,
    width: 25.95,
    height: 37.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8833333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 105.10499999999999
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 123.77,
    width: 25.95,
    height: 41.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 144.60999999999999
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 165.45,
    width: 25.95,
    height: 44.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 187.6
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 209.75,
    width: 25.95,
    height: 44.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 231.99
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254.23,
    width: 25.95,
    height: 49.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 279.03
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 303.83,
    width: 25.95,
    height: 51.69,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 329.67499999999995
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 355.51,
    width: 25.95,
    height: 53.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 382.36
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 409.22,
    width: 25.95,
    height: 54.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 436.69000000000005
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 464.16,
    width: 25.95,
    height: 58.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 493.33000000000004
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 522.5,
    width: 25.95,
    height: 58.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 551.745
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 581,
    width: 25.95,
    height: 59.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 610.68
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 640.36,
    width: 25.95,
    height: 59.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.975,
    y: 670.1800000000001
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 0,
    width: 37.49,
    height: 45.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.248333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.695,
    y: 22.68
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.44,
    y: 0,
    width: 38.16,
    height: 45.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.816
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.52,
    y: 22.68
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.6,
    y: 0,
    width: 38.98,
    height: 45.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.496666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.08999999999999,
    y: 22.68
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.58,
    y: 0,
    width: 39.11,
    height: 45.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.911
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.13500000000002,
    y: 22.68
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.7,
    y: 0,
    width: 41.64,
    height: 45.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.51999999999998,
    y: 22.68
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.34,
    y: 0,
    width: 41.7,
    height: 45.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.957142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.19,
    y: 22.68
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.04,
    y: 0,
    width: 41.96,
    height: 45.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.196
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.02000000000004,
    y: 22.68
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 0,
    width: 42.66,
    height: 45.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.094285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.33,
    y: 22.68
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.66,
    y: 0,
    width: 45.77,
    height: 45.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.545,
    y: 22.68
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.42,
    y: 0,
    width: 46.84,
    height: 45.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4799999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.84000000000003,
    y: 22.68
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.27,
    y: 0,
    width: 47.41,
    height: 45.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.97499999999997,
    y: 22.68
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.68,
    y: 0,
    width: 48.58,
    height: 45.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.97,
    y: 22.68
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.26,
    y: 0,
    width: 51.68,
    height: 45.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.1,
    y: 22.68
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.94,
    y: 0,
    width: 55.43,
    height: 45.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.6550000000001,
    y: 22.68
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.37,
    y: 0,
    width: 56.63,
    height: 45.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.072
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.6850000000001,
    y: 22.68
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 45.36,
    width: 58.23,
    height: 44.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.034545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 67.55
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 89.74,
    width: 58.23,
    height: 44.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.406666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 111.96
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 134.18,
    width: 58.23,
    height: 44.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.9944444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 156.655
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 179.13,
    width: 58.23,
    height: 48.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.881428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 203.215
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 227.3,
    width: 58.23,
    height: 50.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.2128571428571435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 252.54500000000002
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 277.79,
    width: 58.23,
    height: 51.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.398571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 303.685
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 329.58,
    width: 58.23,
    height: 53.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4799999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 356.46
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 383.34,
    width: 58.23,
    height: 57.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 412.2
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 441.06,
    width: 58.23,
    height: 79.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8229999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 480.92
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 520.78,
    width: 58.23,
    height: 88.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.27875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 565.12
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.95,
    y: 609.47,
    width: 58.23,
    height: 90.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.705
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.065,
    y: 654.735
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.18,
    y: 45.36,
    width: 71.08,
    height: 77.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.108
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.72,
    y: 84.12
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.26,
    y: 45.36,
    width: 71.88,
    height: 77.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.534545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.2,
    y: 84.12
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.15,
    y: 45.36,
    width: 88.06,
    height: 77.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.074285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.18,
    y: 84.12
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.21,
    y: 45.36,
    width: 90.99,
    height: 77.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.705,
    y: 84.12
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.2,
    y: 45.36,
    width: 92.2,
    height: 77.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.3,
    y: 84.12
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.41,
    y: 45.36,
    width: 94.79,
    height: 77.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.8050000000001,
    y: 84.12
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.19,
    y: 45.36,
    width: 106.81,
    height: 77.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.595,
    y: 84.12
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.18,
    y: 122.88,
    width: 114.48,
    height: 72.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.0575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.42000000000002,
    y: 159.10999999999999
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.18,
    y: 195.34,
    width: 114.48,
    height: 76.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.54625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.42000000000002,
    y: 233.525
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.18,
    y: 271.71,
    width: 114.48,
    height: 99.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.42000000000002,
    y: 321.525
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.18,
    y: 371.34,
    width: 114.48,
    height: 133.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.42000000000002,
    y: 438.07
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.18,
    y: 504.79,
    width: 114.48,
    height: 195.21,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.896
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.42000000000002,
    y: 602.395
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.66,
    y: 122.88,
    width: 140.77,
    height: 172.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.46166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.045,
    y: 208.95499999999998
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.43,
    y: 122.88,
    width: 167.59,
    height: 172.15,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.235454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.225,
    y: 208.95499999999998
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.03,
    y: 122.88,
    width: 192.97,
    height: 172.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 43.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.515,
    y: 208.95499999999998
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.66,
    y: 295.03,
    width: 173.94,
    height: 200.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.63,
    y: 395.39
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.66,
    y: 495.75,
    width: 173.94,
    height: 204.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.84857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.63,
    y: 597.875
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.6,
    y: 295.03,
    width: 157.68,
    height: 261.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.44000000000005,
    y: 425.585
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.28,
    y: 295.03,
    width: 169.72,
    height: 261.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.286666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.14,
    y: 425.585
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.6,
    y: 556.14,
    width: 327.4,
    height: 143.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.97666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.3,
    y: 628.0699999999999
  }, "\n        Nassau\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1980);
export default __webpack_public_path__ + "static/media/1980.ebd943292abacdc0309adc2ecf858366.svg";
export { ForwardRef as ReactComponent };